import { useErrorBoundary } from "component-library";
import { UserClaimTypes, UserManager } from "core";
import { useQuery } from "react-query";
import AgencyService from "services/AgencyService";
import CastingDirectorService from "services/CastingDirectorService";
import ShortlistService from "services/ShortlistService";
import { getUserAttribute, UserAttributes } from "shared-auth";

const LOAD_SHORTLIST_QUERY_KEY = "loadShortlist";
const LOAD_AGENCIES_QUERY_KEY = "loadAgencies";
const LOAD_CASTING_NOTES_QUERY_KEY = "loadCastingNotes";

export const useLoadShortList = () => {
  const captureError = useErrorBoundary();

  return useQuery({
    queryKey: LOAD_SHORTLIST_QUERY_KEY,
    queryFn: async () => {
      return await ShortlistService.getShortList();
    },
    cacheTime: 0,
    onError: captureError,
  });
};

export const useLoadAgencies = () => {
  const captureError = useErrorBoundary();

  return useQuery({
    queryKey: LOAD_AGENCIES_QUERY_KEY,
    queryFn: async () => {
      return await AgencyService.getAgencies();
    },
    cacheTime: 0,
    onError: captureError,
  });
};

export const useLoadCastingNotes = () => {
  const captureError = useErrorBoundary();

  return useQuery({
    queryKey: LOAD_CASTING_NOTES_QUERY_KEY,
    queryFn: async () => {
      const userId = UserManager.getClaimWithDefault(UserClaimTypes.userId);
      const portalGuid = getUserAttribute(UserAttributes.MasterPortalGuid);

      return await CastingDirectorService.getNotes(userId, portalGuid);
    },
    cacheTime: 0,
    onError: captureError,
  });
};
